/* mo-dvn.js: DreamCloud vs Nectar chooser and layer-stack stage (sections/mo-dvn.liquid), Mattress Overstock, 2026-10-15.
   - Tier, size and per-brand build controls swap the two bed cards, the summary line, the feel pins, the layer lists
     and the drawing. Prices come from the live variants in the section's JSON (server render for the default size).
   - The drawing redraws the server geometry (snippets/mo-dvn-svg.liquid): 14 units per inch, one floor line.
   - Press: a pointer press (or the button) pushes both beds at the same spot. Each band compresses with its own
     response: memory foam and quilted tops sink and recover slowly (first-order lag), support and base foam follow
     at once, coils are an underdamped spring so they push back fast with a small overshoot. It shows the idea, not a
     measurement; the page says so. Frames only change "d"/"transform" attributes (no DOM inserts in a frame), so the
     theme's body MutationObserver (childList) is not woken by the animation. Sleeps when settled or off screen. */
(function () {
  'use strict';
  var root = document.querySelector('[data-dvn]');
  if (!root || root.__dvn) return;
  root.__dvn = true;

  var dataEl = root.querySelector('[data-dvn-json]');
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var BEDS = {};
  DATA.beds.forEach(function (b) { BEDS[b.key] = b; });

  var SVGNS = 'http://www.w3.org/2000/svg';
  var K = 14, FLOOR = 272;
  var GEO = {
    w: { VW: 640, SW: 236, G: [58, 360], FS: 12, DX: 22, DY: -12 },
    n: { VW: 360, SW: 140, G: [30, 194], FS: 9.5, DX: 12, DY: -7 }
  };
  var SCALE = ['Soft', 'Medium-Soft', 'Medium', 'Medium-Firm', 'Firm', 'Extra-Firm'];
  var BRAND = { dreamcloud: 'DreamCloud', nectar: 'Nectar' };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = root.dataset;
  var S = { tier: cfg.tier || 'premier', a: cfg.a || 'hybrid', b: cfg.b || 'foam', size: cfg.size || 'Queen' };

  var sumEl = root.querySelector('[data-dvn-sum]');
  var T = {
    same: root.getAttribute('data-sum-same') || 'In [size], they cost the same.',
    less: root.getAttribute('data-sum-less') || 'In [size], the [brand] costs [diff] less.',
    height: root.getAttribute('data-sum-height') || 'Both are [height] in. tall.',
    none: root.getAttribute('data-none') || 'Not made in [size]',
    np: root.getAttribute('data-np') || 'not published',
    npLong: root.getAttribute('data-np-long') || 'thickness not published'
  };

  function bed(side) { return BEDS[(side === 1 ? 'dreamcloud' : 'nectar') + '-' + S.tier + '-' + (side === 1 ? S.a : S.b)]; }
  function money(c) {
    return '$' + (c / 100).toLocaleString('en-US', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function variant(b) {
    for (var i = 0; i < b.v.length; i++) if (b.v[i].s === S.size) return b.v[i];
    return null;
  }
  function lines(txt) { return (txt || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean); }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function svgEl(tag, attrs, parent) {
    var e = document.createElementNS(SVGNS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(e);
    return e;
  }
  function r1(x) { return Math.round(x * 10) / 10; }

  /* ------------------------------------------------------------ radio groups (roving tabindex, arrows) */
  // Stretch thumb (after 21st.dev 37547 Stretch Tabs): a ghost spans the old and new choice, then lands on the new one.
  // The selected button keeps its own fill (the dark-mode harness reads pressed fills from the element itself).
  function stretch(group, from, to) {
    if (reduce || !from || !to || from === to || !group.animate) return;
    var g = group.getBoundingClientRect(), a = from.getBoundingClientRect(), b = to.getBoundingClientRect();
    var ghost = document.createElement('span');
    ghost.className = 'dvn-seg__ghost';
    ghost.setAttribute('aria-hidden', 'true');
    group.appendChild(ghost);
    function box(r) { return { left: (r.left - g.left) + 'px', top: (r.top - g.top) + 'px', width: r.width + 'px', height: r.height + 'px' }; }
    var u = { left: Math.min(a.left, b.left), top: Math.min(a.top, b.top), right: Math.max(a.right, b.right), bottom: Math.max(a.bottom, b.bottom) };
    var mid = box({ left: u.left, top: u.top, width: u.right - u.left, height: u.bottom - u.top });
    var an = ghost.animate([Object.assign({ offset: 0 }, box(a)), Object.assign({ offset: 0.45, easing: 'cubic-bezier(.22,1,.36,1)' }, mid), Object.assign({ offset: 1 }, box(b))],
      { duration: 380, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' });
    to.classList.add('is-landing');
    an.onfinish = an.oncancel = function () { to.classList.remove('is-landing'); if (ghost.parentNode) ghost.parentNode.removeChild(ghost); };
  }

  function radios(group, onPick) {
    var btns = Array.prototype.slice.call(group.querySelectorAll('[role="radio"]'));
    function pick(btn, focus) {
      var prev = group.querySelector('[aria-checked="true"]');
      stretch(group, prev, btn);
      btns.forEach(function (b) {
        var on = b === btn;
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
      });
      if (focus) btn.focus();
      onPick(btn);
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { if (b.getAttribute('aria-checked') !== 'true') pick(b, false); });
      b.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % btns.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + btns.length) % btns.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = btns.length - 1;
        if (j !== null) { e.preventDefault(); pick(btns[j], true); }
      });
    });
  }

  /* ------------------------------------------------------------ cards, summary, feel, lists */
  var cards = [root.querySelector('.dvn-bed[data-side="1"]'), root.querySelector('.dvn-bed[data-side="2"]')];

  function fillCard(side) {
    var el = cards[side - 1], b = bed(side);
    if (!el || !b) return;
    el.setAttribute('data-key', b.key);
    var v = variant(b);
    var img = el.querySelector('[data-dvn-img]');
    if (img && img.getAttribute('src') !== b.photo) {
      img.setAttribute('src', b.photo);
      img.classList.toggle('is-studio', !/mo-lineup|mo-dvn-/.test(b.photo));
    }
    ['[data-dvn-link]', '[data-dvn-link2]', '[data-dvn-plink]'].forEach(function (s) {
      var a = el.querySelector(s);
      if (a && a.getAttribute('href') !== b.url) a.setAttribute('href', b.url);
    });
    setText(el.querySelector('[data-dvn-name]'), b.name);
    var pe = el.querySelector('[data-dvn-price]'), pt = v ? money(v.p) : T.none.replace('[size]', S.size);
    if (pe && pe.textContent !== pt) {
      pe.textContent = pt;
      if (!reduce && pe.animate) pe.animate([{ transform: 'translateY(.38em)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 280, easing: 'cubic-bezier(.22,1,.36,1)' });
    }
    setText(el.querySelector('[data-dvn-psize]'), v ? S.size : '');
    var vid = el.querySelector('[data-dvn-vid]');
    if (vid && v) vid.value = String(v.id);
    var add = el.querySelector('[data-dvn-add]');
    if (add) add.disabled = !(v && v.a);
    var builds = el.querySelectorAll('[data-build]');
    for (var i = 0; i < builds.length; i++) {
      var on = builds[i].getAttribute('data-build') === (side === 1 ? S.a : S.b);
      builds[i].setAttribute('aria-checked', on ? 'true' : 'false');
      builds[i].tabIndex = on ? 0 : -1;
    }
  }

  function summary() {
    if (!sumEl) return;
    var a = bed(1), b = bed(2), va = variant(a), vb = variant(b), out = [];
    if (a.height === b.height) out.push(T.height.replace('[height]', a.height));
    if (va && vb) {
      if (va.p === vb.p) out.push(T.same.replace('[size]', S.size));
      else {
        var cheap = va.p < vb.p ? 'DreamCloud' : 'Nectar';
        out.push(T.less.replace('[size]', S.size).replace('[brand]', cheap).replace('[diff]', money(Math.abs(va.p - vb.p))));
      }
    }
    setText(sumEl, out.join(' '));
  }

  var diff = root.querySelector('[data-dvn-diff]');
  var ROWS = (root.getAttribute('data-diff-rows') || '').split('|').filter(Boolean).map(function (r) { var i = r.indexOf(':'); return [r.slice(0, i), r.slice(i + 1)]; });
  function rowVal(k, b) {
    var ls = lines(b.layers).map(function (l) { return l.split('|'); }), v = variant(b);
    if (k === 'build') return b.build === 'hybrid' ? 'Hybrid' : 'Memory foam';
    if (k === 'height') return b.height + ' in.';
    if (k === 'feel') return b.firm;
    if (k === 'top') return ls.length ? ls[0][1] : '';
    if (k === 'mf' || k === 'coils') {
      for (var i = 0; i < ls.length; i++) if (ls[i][0] === k) return ls[i][2] ? ls[i][2] + ' in.' : T.np;
      return root.getAttribute('data-diff-none') || 'none';
    }
    if (k === 'price') return v ? money(v.p) : '';
    return '';
  }
  function diffRows() {
    if (!diff) return;
    var body = diff.querySelector('.dvn-diff__body'), a = bed(1), b = bed(2);
    ROWS.forEach(function (r) {
      var row = body.querySelector('[data-row="' + r[0] + '"]');
      if (!row) return;
      var va = rowVal(r[0], a), vb = rowVal(r[0], b), cells = row.querySelectorAll('.dvn-diff__v');
      setText(row.querySelector('.dvn-diff__k'), r[1].replace('[size]', S.size));
      setText(cells[0], va); setText(cells[1], vb);
      row.classList.toggle('is-diff', va !== vb);
    });
  }
  // light up a kind of layer in both drawings while a row or a list item is hovered or focused
  var HL = { mf: /memory foam/i, coils: /coils/i, quilt: /euro top|quilted top/i, support: /support foam/i, base: /base foam/i, pcm: /cooling layer/i };
  function highlight(kind) {
    svgs.forEach(function (svg) { svg.classList.toggle('is-hl-mode', !!kind); });
    stacks.forEach(function (pair) {
      pair.forEach(function (st) {
        st.bands.forEach(function (bd, j) {
          var on = !!kind && (bd.kind === kind || (kind === 'top' && j === 0) || (bd.kind === 'np' && HL[kind] && HL[kind].test(bd.label)));
          bd.el.classList.toggle('is-hl', on);
        });
        st.topf.classList.toggle('is-hl', kind === 'top');
      });
    });
  }
  function hlBind(el, kind) {
    el.addEventListener('mouseenter', function () { highlight(kind()); });
    el.addEventListener('mouseleave', function () { highlight(null); });
    el.addEventListener('focusin', function () { highlight(kind()); });
    el.addEventListener('focusout', function () { highlight(null); });
  }
  if (diff) Array.prototype.forEach.call(diff.querySelectorAll('[data-kind]'), function (r) { hlBind(r, function () { return r.getAttribute('data-kind'); }); });

  var feel = root.querySelector('[data-dvn-feel]');
  var pins = [];
  function feelPins() {
    if (!feel) return;
    var rail = feel.querySelector('.dvn-feel__rail');
    if (!rail) return;
    if (!pins.length) {
      [1, 2].forEach(function (side) {
        var p = document.createElement('span');
        p.className = 'dvn-feel__pin dvn-feel__pin--' + side;
        p.setAttribute('aria-hidden', 'true');
        rail.appendChild(p);
        pins.push(p);
      });
    }
    var ia = SCALE.indexOf(bed(1).firm), ib = SCALE.indexOf(bed(2).firm);
    [ia, ib].forEach(function (ix, k) {
      var p = pins[k];
      setText(p, BRAND[k === 0 ? 'dreamcloud' : 'nectar']);
      p.style.left = ((ix + 0.5) / SCALE.length * 100) + '%';
      p.classList.toggle('is-pair', ia === ib);
    });
    var steps = rail.querySelectorAll('.dvn-feel__step');
    for (var i = 0; i < steps.length; i++) steps[i].classList.toggle('is-on', i === ia || i === ib);
  }

  var lists = root.querySelector('[data-dvn-layers]');
  if (lists) {
    var kindOf = function (e) { var li = e.target.closest && e.target.closest('.dvn-ll__i'); if (!li) return null; var m = li.className.match(/dvn-ll__i--(\w+)/); return m && m[1] !== 'cover' ? (m[1] === 'quilt' ? 'quilt' : m[1]) : null; };
    lists.addEventListener('mouseover', function (e) { highlight(kindOf(e)); });
    lists.addEventListener('mouseleave', function () { highlight(null); });
  }
  function layerLists() {
    if (!lists) return;
    [1, 2].forEach(function (side) {
      var box = lists.querySelector('.dvn-ll[data-side="' + side + '"]');
      var b = bed(side);
      if (!box || box.getAttribute('data-key') === b.key) return;
      box.setAttribute('data-key', b.key);
      setText(box.querySelector('.dvn-ll__h'), BRAND[b.brand] + ' ' + b.name + ', ' + b.height + ' in.');
      var ol = box.querySelector('.dvn-ll__list');
      var html = '';
      lines(b.layers).forEach(function (l) {
        var f = l.split('|');
        var d = f[2] ? f[2] + ' in.' : (f[0] === 'cover' ? 'fabric' : T.np);
        html += '<li class="dvn-ll__i dvn-ll__i--' + f[0] + '"><span class="dvn-ll__sw" aria-hidden="true"></span><span class="dvn-ll__n"></span><span class="dvn-ll__d"></span></li>';
        f.push(d);
      });
      ol.innerHTML = html;
      var lis = ol.children, k = 0;
      lines(b.layers).forEach(function (l) {
        var f = l.split('|');
        lis[k].children[1].textContent = f[1];
        lis[k].children[2].textContent = f[2] ? f[2] + ' in.' : (f[0] === 'cover' ? 'fabric' : T.np);
        k++;
      });
      var src = box.querySelector('.dvn-ll__src a');
      if (src && b.src) src.setAttribute('href', b.src);
    });
  }

  /* ------------------------------------------------------------ drawing */
  var svgs = Array.prototype.slice.call(root.querySelectorAll('.dvn-svg'));
  // How much each kind of layer gives per inch (illustrative): memory foam and quilted tops are the soft layers,
  // support and base foam are stiffer, pocket coils are springs. A bed's total give follows its maker's own feel word
  // (softer word, deeper press), so two beds with the same word sink the same depth and differ only in timing.
  var MOTION = {
    quilt: { m: 'slow', f: 0.5 }, mf: { m: 'slow', f: 0.5 }, pcm: { m: 'fast', f: 0.05 },
    support: { m: 'fast', f: 0.08 }, base: { m: 'fast', f: 0.02 }, coils: { m: 'spring', f: 0.22 }
  };
  var GIVE = { 'Soft': 36, 'Medium-Soft': 32, 'Medium': 28, 'Medium-Firm': 24, 'Firm': 20, 'Extra-Firm': 16 };
  var stacks = [];   // per svg, per side: {g, bands:[...], top, H, SW, x0}

  function bandsOf(b) {
    var out = [], wsum = 0;
    lines(b.bands).forEach(function (l) {
      var f = l.split('|');
      if (f[0] === 'cover') return;
      var motion = f[4] || (MOTION[f[0]] || {}).m || 'slow';
      var frac = MOTION[f[0]] ? MOTION[f[0]].f : (motion === 'spring' ? 0.2 : motion === 'slow' ? 0.3 : 0.06);
      var bd = { kind: f[0], label: f[1], pub: f[2], th: parseFloat(f[3]) * K, motion: motion, c: 0, v: 0, lw: f[5], ln: f[6] };
      bd.w = frac * bd.th; wsum += bd.w;
      out.push(bd);
    });
    var give = GIVE[b.firm] || 24;
    out.forEach(function (bd) { bd.max = Math.min(bd.th * 0.8, wsum ? bd.w / wsum * give : 0); });
    return out;
  }

  function buildStack(svg, geo, side) {
    var b = bed(side);
    var old = svg.querySelector('.dvn-stack[data-side="' + side + '"]');
    var g = svgEl('g', { 'class': 'dvn-stack dvn-stack--' + b.brand, 'data-side': side, transform: 'translate(' + geo.G[side - 1] + ' 0)' });
    var SW = geo.SW, FS = geo.FS, LH = FS + 2, PAD = FS * 0.75, H = parseFloat(b.height) * K, top = FLOOR - H, v = svg.getAttribute('data-v');
    var st = { g: g, b: b, bands: bandsOf(b), top: top, H: H, SW: SW, geo: geo, side: side, s: 1, sv: 0 };
    var cover = b.brand === 'dreamcloud' ? 'rib' : 'knit', topTex = b.brand === 'dreamcloud' ? 'quilt' : 'knit';
    st.shadow = svgEl('path', { 'class': 'dvn-shadow' }, g);
    st.sideF = svgEl('path', { 'class': 'dvn-sideface dvn-sideface--' + b.brand }, g);
    st.sideTex = svgEl('path', { 'class': 'dvn-sidetex', fill: 'url(#dvn-' + cover + '-' + v + ')' }, g);
    st.topf = svgEl('path', { 'class': 'dvn-topface dvn-topface--' + b.brand }, g);
    st.topTex = svgEl('path', { 'class': 'dvn-toptex', fill: 'url(#dvn-' + topTex + '-' + v + ')' }, g);
    var y = top;
    st.bands.forEach(function (bd) {
      bd.y0 = y; bd.y1 = y + bd.th; y = bd.y1;
      bd.el = svgEl('path', { 'class': 'dvn-band dvn-k-' + bd.kind }, g);
      if (!bd.pub) bd.hatch = svgEl('path', { 'class': 'dvn-np', fill: 'url(#dvn-hatch-' + v + ')' }, g);
      if (bd.kind === 'mf' || bd.kind === 'support' || bd.kind === 'base') bd.tex = svgEl('path', { 'class': 'dvn-tex', fill: 'url(#dvn-cells-' + v + ')' }, g);
      if (bd.kind === 'quilt') bd.tex = svgEl('path', { 'class': 'dvn-tex', fill: 'url(#dvn-quilt-' + v + ')' }, g);
      if (bd.kind === 'coils') {
        bd.coils = [];
        var n = Math.floor(SW / 26), pitch = SW / n;
        for (var c = 0; c < n; c++) {
          var cx = (c + 0.5) * pitch;
          bd.coils.push({ x: cx, pocket: svgEl('rect', { 'class': 'dvn-pocket', x: r1(cx - 9.5), width: 19, rx: 6 }, g), spring: svgEl('path', { 'class': 'dvn-coil' }, g) });
        }
      }
      var rows = ((svg.getAttribute('data-v') === 'n' ? bd.ln : bd.lw) || '').split('~').filter(Boolean);
      var t = null;
      if (rows.length) {
        t = svgEl('text', { 'class': 'dvn-blabel' + (bd.pub ? '' : ' dvn-blabel--np') + ' dvn-blabel--k-' + bd.kind, x: PAD, y: r1(bd.y0 + (bd.th - rows.length * LH) / 2 + FS - 1), 'font-size': FS }, g);
        rows.forEach(function (r, i) {
          var ts = svgEl('tspan', { x: PAD, dy: i ? LH : 0 }, t);
          if (r.charAt(0) === '!') { ts.setAttribute('class', 'dvn-blabel__np'); ts.textContent = r.slice(1); }
          else if (/ \u00b7 not published$/.test(r)) {
            ts.appendChild(document.createTextNode(r.replace(/not published$/, '')));
            var it = svgEl('tspan', { 'class': 'dvn-blabel__np' }, ts); it.textContent = T.np;
          } else ts.textContent = r;
        });
      }
      bd.text = t;
    });
    st.outline = svgEl('path', { 'class': 'dvn-outline' }, g);
    st.hl = svgEl('text', { 'class': 'dvn-hlabel', x: SW / 2, y: r1(top + geo.DY - 8), 'text-anchor': 'middle', 'font-size': FS + 1 }, g);
    st.hl.textContent = b.height + ' in. tall';
    if (old) svg.replaceChild(g, old); else svg.insertBefore(g, svg.querySelector('.dvn-pucks'));
    return st;
  }

  var NPTS = 28;
  function shape(st) {
    // displacement of each boundary (top of band j) at sample xs, from the band compressions below it
    var n = st.bands.length, SW = st.SW, x0 = st.px == null ? SW / 2 : st.px;
    var xs = [], i, j, depth = 0, sig = [];
    for (i = 0; i <= NPTS; i++) xs.push(SW * i / NPTS);
    var D = [];
    for (j = 0; j <= n; j++) D.push(new Array(NPTS + 1).fill(0));
    for (j = 0; j < n; j++) { sig.push(SW * 0.13 + depth * 0.55); depth += st.bands[j].th; }
    for (j = n - 1; j >= 0; j--) {
      var c = st.bands[j].c, sg = sig[j];
      for (i = 0; i <= NPTS; i++) {
        var dx = (xs[i] - x0) / sg;
        D[j][i] = D[j + 1][i] + c * Math.exp(-dx * dx);
      }
    }
    st.xs = xs; st.D = D;
  }
  function yOf(st, j) { return j < st.bands.length ? st.bands[j].y0 : FLOOR; }
  function edge(st, j, rev, ox, oy) {
    var xs = st.xs, D = st.D, y = yOf(st, j), out = '', i;
    ox = ox || 0; oy = oy || 0;
    if (!rev) for (i = 0; i < xs.length; i++) out += (i ? ' L' : 'M') + r1(xs[i] + ox) + ' ' + r1(y + D[j][i] + oy);
    else for (i = xs.length - 1; i >= 0; i--) out += ' L' + r1(xs[i] + ox) + ' ' + r1(y + D[j][i] + oy);
    return out;
  }
  function at(st, j, x) {
    var D = st.D, y = yOf(st, j);
    var f = x / st.SW * NPTS, i = Math.max(0, Math.min(NPTS - 1, Math.floor(f))), t = f - i;
    return y + D[j][i] * (1 - t) + D[j][i + 1] * t;
  }

  // Spread: each band lifts by GAP per band below it (E 0..1). Spread is not to scale; the page says so while it shows.
  function off(st, j) { return -E * (st.geo.FS * 0.85) * (st.bands.length - 1 - j); }
  function paint(st) {
    shape(st);
    var DX = st.geo.DX, DY = st.geo.DY, SW = st.SW, o0 = off(st, 0);
    var topR = at(st, 0, SW) + o0;
    var sideD = 'M' + SW + ' ' + r1(topR) + ' L' + (SW + DX) + ' ' + r1(topR + DY) + ' L' + (SW + DX) + ' ' + (FLOOR + DY) + ' L' + SW + ' ' + FLOOR + ' Z';
    st.sideF.setAttribute('d', sideD); st.sideTex.setAttribute('d', sideD);
    var topD = edge(st, 0, false, 0, o0) + edge(st, 0, true, DX, DY + o0) + ' Z';
    st.topf.setAttribute('d', topD); st.topTex.setAttribute('d', topD);
    st.bands.forEach(function (bd, j) {
      var oj = off(st, j);
      var d = edge(st, j, false, 0, oj) + edge(st, j + 1, true, 0, oj) + ' Z';
      bd.el.setAttribute('d', d);
      if (bd.hatch) bd.hatch.setAttribute('d', d);
      if (bd.tex) bd.tex.setAttribute('d', d);
      if (bd.coils) bd.coils.forEach(function (c) {
        var yt = at(st, j, c.x) + 3 + oj, yb = at(st, j + 1, c.x) - 3 + oj, span = Math.max(2, yb - yt - 6), stp = span / 6;
        var ry = Math.min(2.6, stp * 0.42), p = '';
        c.pocket.setAttribute('y', r1(yt)); c.pocket.setAttribute('height', r1(Math.max(4, yb - yt)));
        for (var t = 0; t < 6; t++) {
          var ty = r1(yt + 3 + (t + 0.5) * stp);
          p += 'M' + r1(c.x - 5.5) + ' ' + ty + ' a5.5 ' + r1(ry) + ' 0 1 0 11 0 a5.5 ' + r1(ry) + ' 0 1 0 -11 0 ';
        }
        c.spring.setAttribute('d', p);
      });
      if (bd.text) {
        var lx = Math.min(SW, st.geo.FS * 6);
        var m = ((at(st, j, lx) - bd.y0) + (at(st, j + 1, lx) - bd.y1)) / 2 + oj;
        bd.text.setAttribute('transform', Math.abs(m) > 0.05 ? 'translate(0 ' + r1(m) + ')' : '');
      }
    });
    st.outline.setAttribute('d', edge(st, 0, false, 0, o0) + ' L' + SW + ' ' + FLOOR + ' L0 ' + FLOOR + ' Z' +
      ' M' + (SW + DX) + ' ' + r1(topR + DY) + ' L' + (SW + DX) + ' ' + (FLOOR + DY) + ' L' + SW + ' ' + FLOOR +
      ' M0 ' + r1(at(st, 0, 0) + o0) + ' L' + DX + ' ' + r1(at(st, 0, 0) + DY + o0) + edge(st, 0, false, DX, DY + o0).replace(/^M/, ' L') + ' L' + SW + ' ' + r1(topR));
    var fade = E > 0.002 ? String(Math.max(0, 1 - E * 1.2).toFixed(3)) : null;
    [st.outline, st.sideF, st.sideTex].forEach(function (el) { if (fade === null) el.removeAttribute('opacity'); else el.setAttribute('opacity', fade); });
    st.hl.setAttribute('y', r1(st.top + DY - 8 + o0));
    if (fade === null) st.hl.removeAttribute('opacity'); else st.hl.setAttribute('opacity', String(Math.max(0, 1 - E * 2).toFixed(3)));
    st.shadow.setAttribute('d', 'M-2 ' + (FLOOR - 1) + ' H' + (SW + DX + 4) + ' L' + (SW + DX + 4) + ' ' + (FLOOR + 3) + ' H-2 Z');
    var s = st.s;
    st.g.setAttribute('transform', 'translate(' + st.geo.G[st.side - 1] + ' ' + (s === 1 ? 0 : r1(FLOOR * (1 - s))) + ')' + (s === 1 ? '' : ' scale(1 ' + s.toFixed(4) + ')'));
  }

  function rebuild(morph) {
    var prev = stacks.map(function (pair) { return pair.map(function (st) { return st.H; }); });
    stacks = svgs.map(function (svg) {
      var geo = GEO[svg.getAttribute('data-v')] || GEO.w;
      return [buildStack(svg, geo, 1), buildStack(svg, geo, 2)];
    });
    stacks.forEach(function (pair, si) {
      pair.forEach(function (st, k) {
        if (morph && !reduce && prev[si] && prev[si][k] && prev[si][k] !== st.H) st.s = prev[si][k] / st.H;
        paint(st);
      });
    });
    if (morph) kick();
  }

  /* ------------------------------------------------------------ press physics */
  var F = 0, pressing = false, raf = 0, last = 0, rel = 0.5, visible = true, E = 0, Ev = 0, Et = 0;
  var pucks = svgs.map(function (svg) {
    var g = svg.querySelector('.dvn-pucks');
    return [1, 2].map(function () {
      var p = svgEl('g', { 'class': 'dvn-puckg', opacity: 0 }, g);
      svgEl('circle', { 'class': 'dvn-puck', r: 9, cx: 0, cy: 0 }, p);
      svgEl('circle', { 'class': 'dvn-puck-ring', r: 13, cx: 0, cy: 0 }, p);
      return p;
    });
  });

  // physics in fixed substeps of at most 1/120 s, so a slow device or a throttled tab runs at true speed
  function physics(h) {
    var moving = false, target = pressing ? 1 : 0;
    if (E !== Et || Ev) {
      var ea = 110 * (Et - E) - 2 * 0.62 * 10.5 * Ev;
      Ev += ea * h; E += Ev * h;
      if (Math.abs(Et - E) < 0.001 && Math.abs(Ev) < 0.005) { E = Et; Ev = 0; } else moving = true;
    }
    F += (target - F) * Math.min(1, h / 0.08);
    stacks.forEach(function (pair) {
      pair.forEach(function (st) {
        if (st.s !== 1 || st.sv) {
          var acc = 150 * (1 - st.s) - 2 * 0.55 * 12.2 * st.sv;
          st.sv += acc * h; st.s += st.sv * h;
          if (Math.abs(1 - st.s) < 0.0015 && Math.abs(st.sv) < 0.01) { st.s = 1; st.sv = 0; } else moving = true;
        }
        st.bands.forEach(function (bd) {
          var goal = F * bd.max;
          if (bd.motion === 'spring') {
            var w = 15, z = 0.3;
            var a2 = w * w * (goal - bd.c) - 2 * z * w * bd.v;
            bd.v += a2 * h; bd.c += bd.v * h;
          } else if (bd.motion === 'slow') {
            var tau = goal > bd.c ? 0.5 : 1.35;
            bd.c += (goal - bd.c) * Math.min(1, h / tau);
          } else {
            bd.c += (goal - bd.c) * Math.min(1, h / 0.05);
          }
          if (Math.abs(goal - bd.c) > 0.05 || Math.abs(bd.v) > 0.05) moving = true;
        });
      });
    });
    return moving;
  }

  function step(dt) {
    var moving = false, n = Math.max(1, Math.ceil(dt / 0.0083)), h = dt / n;
    for (var i = 0; i < n; i++) moving = physics(h) || moving;
    stacks.forEach(function (pair) {
      pair.forEach(function (st) { st.px = rel * st.SW; paint(st); });
    });
    pucks.forEach(function (pair, si) {
      pair.forEach(function (p, k) {
        var st = stacks[si][k], gx = st.geo.G[k], x = st.px, y = at(st, 0, x) - 13;
        p.setAttribute('transform', 'translate(' + r1(gx + x) + ' ' + r1(y) + ')');
        p.setAttribute('opacity', r1(Math.min(1, F * 1.6)));
      });
    });
    return moving || pressing || F > 0.01;
  }

  function loop(t) {
    raf = 0;
    var dt = last ? Math.min(0.12, (t - last) / 1000) : 0.016;
    last = t;
    if (step(dt) && visible) raf = requestAnimationFrame(loop);
    else { last = 0; }
  }
  function kick() { if (!raf && !reduce) { last = 0; raf = requestAnimationFrame(loop); } }
  stacks = [];

  function press(on, x) {
    if (reduce) return;
    if (x != null) rel = Math.max(0.08, Math.min(0.92, x));
    pressing = on;
    kick();
  }

  svgs.forEach(function (svg, si) {
    svg.addEventListener('pointerdown', function (e) {
      var pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY;
      var m = svg.getScreenCTM(); if (!m) return;
      var p = pt.matrixTransform(m.inverse());
      var geo = GEO[svg.getAttribute('data-v')] || GEO.w;
      var k = p.x > (geo.G[0] + geo.SW + geo.G[1]) / 2 ? 1 : 0;
      var x = (p.x - geo.G[k]) / geo.SW;
      if (x < -0.05 || x > 1.05) return;
      press(true, x);
      try { svg.setPointerCapture(e.pointerId); } catch (err) {}
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (ev) {
      svg.addEventListener(ev, function () { if (pressing) press(false); });
    });
  });
  var pbtn = root.querySelector('[data-dvn-press]');
  var cycle = 0;
  function pressOnce(x, hold) {
    clearTimeout(cycle);
    press(true, x);
    cycle = setTimeout(function () { press(false); }, hold || 1100);
  }
  if (pbtn) {
    if (reduce) pbtn.hidden = true;
    pbtn.addEventListener('click', function () { pressOnce(0.5, 1100); });
  }

  var stage = root.querySelector('[data-dvn-stage]');
  var sbtn = root.querySelector('[data-dvn-spread]');
  function spread(on) {
    Et = on ? 1 : 0;
    if (stage) stage.classList.toggle('is-spread', !!on);
    if (sbtn) { sbtn.setAttribute('aria-pressed', on ? 'true' : 'false'); setText(sbtn, on ? (sbtn.getAttribute('data-on') || '') : (sbtn.getAttribute('data-off') || '')); }
    if (reduce) { E = Et; Ev = 0; stacks.forEach(function (pair) { pair.forEach(paint); }); }
    else kick();
  }
  if (sbtn) sbtn.addEventListener('click', function () { spread(sbtn.getAttribute('aria-pressed') !== 'true'); });

  /* first view, once: the layers spread apart, hold, settle back on the floor line, then both beds take one press.
     Then it waits for the shopper. Reduced motion skips it. */
  if (stage && 'IntersectionObserver' in window) {
    var played = false;
    new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        visible = e.isIntersecting;
        if (visible && !played && !reduce) {
          played = true;
          setTimeout(function () { spread(true); }, 350);
          setTimeout(function () { spread(false); }, 1700);
          setTimeout(function () { pressOnce(0.5, 1100); }, 2500);
        }
        if (visible) kick();
      });
    }, { threshold: 0.45 }).observe(stage);
  }

  /* ------------------------------------------------------------ wire up */
  function update(what) {
    cards.forEach(function (c, i) { if (c && (what === 'all' || what === i + 1)) { c.classList.add('is-swap'); } });
    fillCard(1); fillCard(2);
    summary(); feelPins(); layerLists(); diffRows();
    F = 0; pressing = false;
    rebuild(true);
    requestAnimationFrame(function () { cards.forEach(function (c) { if (c) c.classList.remove('is-swap'); }); });
  }

  var tierG = root.querySelector('.dvn-seg--tier');
  if (tierG) radios(tierG, function (b) { S.tier = b.getAttribute('data-tier'); update('all'); });
  var sizeG = root.querySelector('.dvn-seg--size');
  if (sizeG) radios(sizeG, function (b) { S.size = b.getAttribute('data-size'); fillCard(1); fillCard(2); summary(); diffRows(); });
  cards.forEach(function (c, i) {
    var g = c && c.querySelector('.dvn-seg--build');
    if (g) radios(g, function (b) { if (i === 0) S.a = b.getAttribute('data-build'); else S.b = b.getAttribute('data-build'); update(i + 1); });
  });

  // open a disclosure of the long version when its anchor is linked
  function openHash() {
    var h = location.hash && document.getElementById(location.hash.slice(1));
    if (h && h.tagName === 'DETAILS') h.open = true;
  }
  window.addEventListener('hashchange', openHash);
  openHash();

  // read-only snapshot for qa/flows.py: per wide-drawing stack, each band's kind and current compression (units)
  root.dvnState = function () {
    return stacks.length ? stacks[0].map(function (st) { return st.bands.map(function (bd) { return [bd.kind, Math.round(bd.c * 100) / 100]; }); }) : [];
  };

  feelPins();
  rebuild();
})();
